import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

const DeleteAccount: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Delete Account — FitMind AI';
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo.png" alt="FitMind AI" />
        </Link>
      </header>
      <main className="legal-main container">
        <div className="legal-content">
          <div className="legal-title-block">
            <span className="legal-tag">Account</span>
            <h1>Delete Your Account & Data</h1>
            <p className="legal-meta">Your data, your choice</p>
          </div>

          <p className="legal-intro">
            You can request the deletion of your FitMind AI account and all associated personal data at any time.
            Once deleted, your data cannot be recovered.
          </p>

          <section className="legal-section">
            <h2>What Gets Deleted</h2>
            <p>When you request account deletion, we permanently remove:</p>
            <ul>
              <li>Your account credentials (email, display name, profile photo)</li>
              <li>Onboarding and profile data (goals, fitness level, body stats)</li>
              <li>All workout sessions, sets, reps, and exercise history</li>
              <li>Body weight entries, measurements, and progress photos</li>
              <li>Nutrition diary entries and food logs</li>
              <li>AI Coach conversation history</li>
              <li>Push notification tokens and app preferences</li>
            </ul>
            <p>
              Subscription billing records are managed by our payment processor and may be
              retained by them according to their own policies.
            </p>
          </section>
          <section className="legal-section">
            <h2>How to Delete Your Account</h2>
            <div className="legal-subsection">
              <h3>Option 1 — From Within the App</h3>
              <ol>
                <li>Open FitMind AI and go to <strong>Profile</strong></li>
                <li>Tap <strong>Settings</strong></li>
                <li>Scroll down and tap <strong>Delete Account</strong></li>
                <li>Confirm the deletion when prompted</li>
              </ol>
              <p>Your account and all data will be deleted immediately.</p>
            </div>

            <div className="legal-subsection">
              <h3>Option 2 — By Email</h3>
              <p>
                Send a deletion request to{' '}
                <a href="mailto:fitmindai@gmail.com?subject=Account%20Deletion%20Request">
                  fitmindai@gmail.com
                </a>{' '}
                from the email address associated with your account. Include "Account Deletion Request"
                in the subject line. We will process your request and confirm deletion within <strong>30 days</strong>.
              </p>
            </div>
          </section>
          <section className="legal-section">
            <h2>Data Retention After Deletion</h2>
            <p>
              All personal data is deleted within <strong>30 days</strong> of your request. Anonymised,
              non-identifiable usage statistics may be retained for app improvement purposes.
              We are not required by law to retain any of your personal data beyond this period.
            </p>
          </section>
          <section className="legal-section">
            <h2>Questions?</h2>
            <p>If you have any questions about account deletion or your data, contact us:</p>
            <div className="legal-contact-box">
              <div><strong>FitMind AI</strong></div>
              <div>Email: <a href="mailto:fitmindai@gmail.com">fitmindai@gmail.com</a></div>
            </div>
          </section>
        </div>
      </main>
      <footer className="legal-footer">
        <div className="container">
          <Link to="/">← Back to FitMind AI</Link>
          <span>·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms">Terms of Service</Link>
          <span>·</span>
          <span>© {new Date().getFullYear()} FitMind AI</span>
        </div>
      </footer>
    </div>
  );
};

export default DeleteAccount;
